import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';
import { AuthGuard } from './guards';
import { ManagementAppRoutes } from './management';
import ManagementLayout from '../layouts/management';
import { TransporterAppRoutes } from './transporter';
import LogisticsTwo from '../layouts/logisticsTwo';
import { TransportAgentAppRoutes } from './trasnport-agent';
import CustomerLayout from '../layouts/customer';
import { pdpAppRoutes } from './pdp';
import { pdpCustomerAppRoutes } from './pdp/customer';
import LogisticsLayout from '../layouts/logistics';
import LogisticsLayoutTwo from '../layouts/logisticsTwo';
import { mspCustomerAppRoutes } from './msp/customer';
import { smpAppRoutes } from './smp';
import { smpCustomerAppRoutes } from './smp/customer';
import TransportAgentLayout from '../layouts/transport-agent';
import { mspAppRoutes } from './msp';


const AppRouter: React.FC = () => {
  let SUBSCRIPTION_TYPE: string = process.env.REACT_APP_SUBSCRIPTION_TYPE || '';
  console.log('SUBSCRIPTION_TYPE', SUBSCRIPTION_TYPE)


  const preparePDPRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/',
        element: <LogisticsLayout />, children: pdpAppRoutes(),
      },
      {
        path: '/customer/*',
        element: <AuthGuard><CustomerLayout /></AuthGuard>, children: pdpCustomerAppRoutes(),
      },
      {
        path: '/transport-agent/*',
        element: <AuthGuard><TransportAgentLayout /></AuthGuard>, children: TransportAgentAppRoutes(),
      },
      {
        path: '/transporter/*',
        element: <AuthGuard><LogisticsLayoutTwo /></AuthGuard>, children: TransporterAppRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

    ];
    return routes;
  }

  const prepareMSPRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/',
        element: <LogisticsLayout />, children: mspAppRoutes(),
      },
      {
        path: '/customer/*',
        element: <AuthGuard><CustomerLayout /></AuthGuard>, children: mspCustomerAppRoutes(),
      },
      {
        path: '/transport-agent/*',
        element: <AuthGuard><TransportAgentLayout /></AuthGuard>, children: TransportAgentAppRoutes(),
      },
      {
        path: '/transporter/*',
        element: <AuthGuard><LogisticsTwo /></AuthGuard>, children: TransporterAppRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

    ];
    return routes;
  }

  const prepareSMPRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/',
        element: <LogisticsLayout />, children: smpAppRoutes(),
      },
      {
        path: '/customer/*',
        element: <AuthGuard><CustomerLayout /></AuthGuard>, children: smpCustomerAppRoutes(),
      },
      {
        path: '/rap-agent/*',
        element: <AuthGuard><TransportAgentLayout /></AuthGuard>, children: TransportAgentAppRoutes(),
      },
      {
        path: '/rap/*',
        element: <AuthGuard><LogisticsTwo /></AuthGuard>, children: TransporterAppRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

    ];
    return routes;
  }


  switch (SUBSCRIPTION_TYPE) {
    case 'PDP':
      console.log('Running PDP')
      return (
        <RouterProvider router={createBrowserRouter(preparePDPRoutes())} />
      );
    case 'MSP':
      console.log('Running MSP')
      return (
        <RouterProvider router={createBrowserRouter(prepareMSPRoutes())} />
      );
    case 'SMP':
      console.log('Running SMP')
      return (
        <RouterProvider router={createBrowserRouter(prepareSMPRoutes())} />
      );
    default:
      return null
  }

};

export default AppRouter;
